// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1vZdWBiDOVb9Bv8CP6HDN7","stats":"M6Alqy8eIiaHNSm7hncmY"};